export default "/assets/images/smiling-girl.7aef656cbab80d36.jpg";